import { useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useToast } from "@circle-react-uikit/ToastV2";

const i18nRoot = "settings.workflows.form";

export const useFetchSection = ({ sectionId }: { sectionId: string }) => {
  const { error } = useToast();

  return useQuery(
    ["workflows", "list", "sections", sectionId],
    () =>
      // TODO: add correct type defintion on the backend
      reactQueryGet<unknown>(
        internalApi.settings.courses.sections.show({ id: sectionId }),
      ),
    {
      onError: () => error(t([i18nRoot, "errors", "sections", "fetch_failed"])),
      enabled: !!sectionId,
    },
  );
};
